import React from 'react';

export default React.createContext({
    open: false,
    setOpen: open => !open
})